<template>
  <div
    class="subheader py-3 py-lg-8 subheader-transparent"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
      style="padding-right: 0px;"
    >
      <div
        class="d-flex align-items-baseline mr-5"
        style="display: block !important; width: 100%;"
      >
        <!--begin::Page Title-->
        <h2 class="subheader-title text-dark font-weight-bold my-2 mr-3">
          {{ title }}
        </h2>
        <!--end::Page Title-->
        <!--begin::Breadcrumb-->
        <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold my-2 p-0"
        >
          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li :key="`${i}-${breadcrumb.id}`" class="breadcrumb-item">
              <router-link
                :key="`${i}-${breadcrumb.id}`"
                v-if="breadcrumb.route"
                :to="breadcrumb.route"
                class="text-muted"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span
                class="text-muted"
                :key="`${i}-${breadcrumb.id}`"
                v-if="!breadcrumb.route"
              >
                {{ breadcrumb.title }}
              </span>
            </li>
          </template>
        </ul>
        <!--end::Breadcrumb-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  mounted() {
    let vm = this;

    this.$root.$on("trocaTipoPR", function() {
      vm.buscarFluxos();
    });
  },
  computed: {
    ...mapGetters([
      "layoutConfig",
      "fgDataInicio",
      "fgDataFim",
      "fgEmpresa",
      "fgProjeto",
      "fgPlanoFinanceiro",
      "fgCentroDeResponsabilidade",
      "fgPortador",
      "fgLoading",
      "fgModoPR",
      "fluxoDeCaixaBusca",
      "fgFiltroAbas",
      "fgDataFiltroTipo",
      "fgEmitente",
      "fgOrdenacaoFiltroTipo"
    ]),
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },
    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");

      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }

        if (this.layoutConfig("subheader.clear")) {
          classes.push("mb-0");
        }
      }

      return classes.join(" ");
    }
  },
  methods: {
    ...mapActions([
      "updateFgDataInicio",
      "updateFgDataFim",
      "getFluxosDeCaixa",
      "updateFgLoading"
    ]),
    buscarFluxos() {
      let vm = this;
      this.updateFgLoading(true);

      this.getFluxosDeCaixa({
        inicio: this.fgDataInicio,
        fim: this.fgDataFim,
        empresa: this.fgEmpresa,
        projeto: this.fgProjeto,
        planoFinanceiro: this.fgPlanoFinanceiro,
        centroDeResponsabilidade: this.fgCentroDeResponsabilidade,
        portador: this.fgPortador,
        tipo: this.fgModoPR,
        fluxoDeCaixaBusca: this.fluxoDeCaixaBusca,
        filtroAbas: this.fgFiltroAbas,
        dataFiltroTipo: this.fgDataFiltroTipo,
        emitente: this.fgEmitente,
        ordenacaoFiltroTipo: this.fgOrdenacaoFiltroTipo
      }).then(function() {
        vm.updateFgLoading(false);
      });
    }
  }
};
</script>
